// extracted by mini-css-extract-plugin
export default {"map-mode-switcher":"map-tools_map-mode-switcher__XYQQ1"};